module.exports = __webpack_public_path__ + "static/media/pvo6224.54c863dd.jpg";